import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'micro-environment-detail',
  templateUrl: './environment-detail.component.html'
})
export class EnvironmentDetailComponent implements OnInit {
  @Input()
  environmentId:any;

  environment:any;

  @Output()
  persisted:EventEmitter<any> = new EventEmitter<any>();

  constructor(private env: EnvService,
              private http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              public authService:AuthService,
              private alertService:AlertService) {
  }

  public ngOnInit(): void {
    if (this.environmentId) {
      this.load(this.environmentId);
    } else {
      this.route.params
        .subscribe((params: Params) => {
          let id:any = params['id'];
          if (id === '0') {
            this.createNew();
          } else {
            this.load(id);
          }
        });
    }
  }

  load(id:any) {
    this.http.get(`${this.env.e.url}/domain/environments/${id}`).subscribe(
      data => {
        this.setEnvironment(data)
      }
    );
  }

  setEnvironment(environment:any) {
    this.environment = environment;
  }

  createNew() {
    this.environment = {
    };
  }

  save() {
    if (!this.environment.id) {
      this.http.post(`${this.env.e.url}/domain/environments`, this.environment)
        .subscribe(
          data => {
            this.setEnvironment(data)
            this.alertService.info(`Created ${this.environment.name}`);
            this.persisted.emit({
              data: data,
              action: 'added'
            });
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/domain/environments/${this.environment.id}`, this.environment)
        .subscribe(
          data => {
            this.setEnvironment(data)
            this.alertService.info(`Updated`);
            this.persisted.emit({
              data: data,
              action: 'updated'
            });
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/domain/environments/${this.environment.id}`)
      .subscribe(
        complete => {
          this.persisted.emit({
            data: this.environment,
            action: 'deleted'
          });
          this.alertService.info(`Deleted ${this.environment.name}`);
          if (!this.environmentId) {
            this.router.navigate(["/domain/environments"]);
          }
        }
      );
  }

  onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.environment.active = target.checked ? 'Y' : 'N'
  }
}
